<template>
  <div class="app">
    <div class="page_title">首页</div>
    <div class="dis" style="align-items: flex-start;">
      <div style="flex: 1;">
        <div class="head dis_between">
          <div class="head1 dis_center" @click="jump(0)">
            <img class="head_img4" src="../../assets/6.png" alt="" />
            <div>
              <div class="head_title">项目总数</div>
              <div class="head_value">{{ obj.totalProjects || 0 }}</div>
            </div>
          </div>
          <div class="head1 dis_center" @click="jump(1)">
            <img class="head_img4" src="../../assets/7.png" alt="" />
            <div>
              <div class="head_title">到期项目数</div>
              <div class="head_value">{{ obj.expiretProjects || 0 }}</div>
            </div>
          </div>
          <div class="head1 dis_center" @click="jump(2)">
            <img class="head_img4" src="../../assets/8.png" alt="" />
            <div>
              <div class="head_title">客户数</div>
              <div class="head_value">{{ obj.customers || 0 }}</div>
            </div>
          </div>
          <div class="head1 dis_center" @click="jump(3)">
            <img class="head_img4" src="../../assets/9.png" alt="" />
            <div>
              <div class="head_title">付费数</div>
              <div class="head_value">{{ obj.totalOrders || 0 }}</div>
            </div>
          </div>
        </div>
        <div class="echart_box">
          <div class="title">
            <div class="dis">
              <div class="title_text">近7天付费查看次数</div>
            </div>
          </div>
          <div class="chart_box" ref="lineEchart"></div>
        </div>
      </div>
      <div class="phb">
        <div class="phb_title">付费查看项目排行榜</div>
        <div class="table">
          <div class="dis t_head">
            <div style="flex: 1;">排名</div>
            <div style="flex: 2;">项目名称</div>
            <div style="flex: 2;">付费次数</div>
          </div>
          <div class="dis t_box" v-for="item in tableData">
            <div style="flex: 1;" class="dis_center">
              <div style="background: #FFF1F3;width: 20rem;height: 20rem;border-radius: 50%;color: #C1272D;">{{
                item.rankNo }}</div>
            </div>
            <div style="flex: 2;">{{ item.attribute }}</div>
            <div style="flex: 2;">{{ item.total }}</div>
          </div>
        </div>
        <div class="page_box">
          <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
            :current-page.sync="pageNumber" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
var Chart = require("echarts");
import { getProjectContractStatistics, getProjectOrderRank } from "../js/api";
export default {
  data() {
    return {
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      //折线
      data1: {
        // title: {
        //   text: "ECharts 入门示例",
        // },
        // //鼠标移动显示
        tooltip: {
          trigger: "axis",
        },
        legend: {
          //设置legend颜色
          data: [{ name: "付费数", textStyle: { color: "#0095c3" } }],
          left: "right",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], //设置x轴字体颜色
          axisLine: {
            lineStyle: {
              color: "#0095c3",
              width: 2,
            },
          },
        },
        yAxis: {
          type: "value", //设置y轴字体颜色
          axisLine: {
            lineStyle: {
              color: "#0095c3",
              width: 2,
            },
          },
        },
        series: [
          {
            name: "付费数",
            data: [0, 0, 0, 0, 0, 0, 0],
            type: "line",
            smooth: true, //设置背景颜色
            areaStyle: {
              opacity: 0.2,
              color: "#2893F5",
            },
            showSymbol: false, //线上点
            color: "#2893F5", //线色
          },
        ],
      },
      // 柱状图
      data2: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {
          right: 30,
          textStyle: { color: "#0095c3" },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "收益",
            type: "bar",
            stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [320, 302, 301, 334, 390, 330, 320],
          },
          // {
          //   name: "Mail Ad",
          //   type: "bar",
          //   stack: "total",
          //   label: {
          //     show: true,
          //   },
          //   emphasis: {
          //     focus: "series",
          //   },
          //   data: [120, 132, 101, 134, 90, 230, 210],
          // },
        ],
      },
      obj: {
        countByStoreUsers: null,
        countByStoreUserCoupons: null,
        countByStoreOrders: null
      },
    };
  },
  mounted() {
    let that = this;

    // that.getList2();
    // that.setEchart();
    // this.tableData = [
    //   { a: "a", b: "b", c: "c", d: "d", e: "e" },
    //   { a: "a", b: "b", c: "c", d: "d", e: "e" },
    //   { a: "a", b: "b", c: "c", d: "d", e: "e" },
    // ];
    // this.setEchart();
  },
  created() {
    this.ajaxload();
    this.getList();
  },
  methods: {
    jump_more(e) {
      let that = this;
      that.$router.push("./detailedData?type=" + e);
    },
    jump(e) {
      let that = this;
      return;
      switch (e) {
        case 0:
          that.$router.push("./roomManageList?value7=2");
          break;
        case 1:
          that.$router.push("./roomManageList?value7=1");
          break;
        case 2:
          that.$router.push("./PropertyManagementList");
          break;
        case 3:
          that.$router.push("./Historicalbilling?value3=0");
          break;
        case 4:
          let date = new Date();
          let mouth = date.getMonth() + 1;
          if (mouth < 10) {
            mouth = "0" + mouth;
          }
          let day = date.getDate();
          if (day < 10) {
            day = "0" + day;
          }
          let t = date.getHours();
          if (t < 10) {
            t = "0" + t;
          }
          let m = date.getMinutes();
          if (m < 10) {
            m = "0" + m;
          }
          let s = date.getSeconds();
          if (s < 10) {
            s = "0" + s;
          }
          // console.log(mouth, day, t, m, s);
          let expireDate =
            date.getFullYear() +
            "-" +
            mouth +
            "-" +
            mouth +
            " " +
            t +
            ":" +
            m +
            ":" +
            s;
          that.$router.push(
            "./Historicalbilling?value3=0&expireDate=" + expireDate
          );
          break;
      }
    },
    ajaxload() {
      let that = this;
      let json = {};
      getProjectContractStatistics(json).then((res) => {
        console.log(res);
        if (res.code == 200) {
          let data = res.data;
          that.obj = data;

          // 处理orders数据，转换为折线图格式
          let list1 = []; // 日期数组
          let list2 = []; // total数组

          if (data.orders) {
            // 获取所有日期并排序
            let dates = Object.keys(data.orders).sort();

            for (let date of dates) {
              list1.push(date);
              // 处理null值情况，如果orders[date]为null或者total为null，则使用0
              let total = 0;
              if (data.orders[date] && data.orders[date].total !== null) {
                total = data.orders[date].total;
              }
              list2.push(total);
            }
          }

          that.data1.xAxis.data = list1;
          that.data1.series[0].data = list2;
          this.$nextTick(() => {
            that.setEchart();
          });
          // this.chart1 = Chart.init(this.$refs.lineEchart);
          // this.chart1.setOption(this.data1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getList() {
      let that = this;

      let json = {
        entityParam: {},
        pageReq: {
          pageNumber: that.pageNumber,
          pageSize: that.pageSize
        }
      };
      getProjectOrderRank(json).then((res) => {
        console.log(res);
        if (res.code == 200) {
          let data = res.data;
          that.tableData = data.records;
          that.tabtal = data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getList2() {
      let that = this;
      let json = {};
      PayRentRecordstatisticByFlast({ params: json }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          let data = res.data;
          let list1 = [];
          let list2 = [];
          for (let i in data) {
            list1.push(data[i].name);
            list2.push(data[i].total / 100);
          }
          that.data2.xAxis.data = list1;
          that.data2.series[0].data = list2;
          this.chart2 = Chart.init(this.$refs.SCEchart);
          this.chart2.setOption(this.data2);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getList3() {
      let that = this;
      let json = {};
      FlatsRoomrankList({ params: json }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          let data = res.data;
          for (let i in data) {
          }
          that.list = data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    setEchart() {
      this.chart1 = Chart.init(this.$refs.lineEchart);
      this.chart1.setOption(this.data1);

      this.chart2 = Chart.init(this.$refs.SCEchart);
      this.chart2.setOption(this.data2);
    },

    handleCurrentChange(val) {
      let that = this;
      that.pageNumber = val;
      that.getList();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("./home.css");
</style>



// WEBPACK FOOTER //
// src/view/home/home.vue